import React from 'react'
import CodeMirror from '@uiw/react-codemirror'
import { Spinner } from 'transfix-ui/components/Spinner'
import { Box, makeStyles, Typography } from 'transfix-ui/core'

interface IQueryResultsProps {
  isLoading: boolean
  jsonResult: string
  ediResult: string
}

const useStyles = makeStyles(() => ({
  row: {
    width: '100%',
    direction: 'ltr',
    display: 'flex',
    alignItems: 'left',
    justifyContent: 'left',
  },
  rowCenter: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  editor: {
    borderRight: '1px solid',
    '& .cm-content': {
      border: '1px solid',
      borderRight: 'none',
    },
    '& .cm-lineNumbers': {
      minWidth: 33,
    },
    '& .cm-line::selection': {
      backgroundColor: '#d9d9d9 !important',
    },
  },
  column: {
    flex: 5,
  },
}))

export const QueryResults = ({ ediResult, isLoading, jsonResult }: IQueryResultsProps) => {
  const classes = useStyles()

  return (
    <>
      <hr />
      <Box component='div' mt={3} ml={2} className={`${classes.row}`}>
        <Typography variant='h3'>Results:</Typography>
      </Box>
      {isLoading ? (
        <Spinner position='relative' />
      ) : (
        <Box component='div' className={classes.row}>
          <Box className={`${classes.column}`} marginX={2}>
            <Box
              marginY={1}
              display='flex'
              flexDirection='row'
              flexWrap='wrap'
              justifyContent='space-between'>
              <Typography variant='h3'>JSON</Typography>
            </Box>
            <CodeMirror
              height='40vh'
              maxWidth='50vw'
              className={classes.editor}
              value={jsonResult}
              editable={false}
            />
          </Box>
          <Box className={`${classes.column}`} marginX={2}>
            <Box
              marginY={1}
              display='flex'
              flexDirection='row'
              flexWrap='wrap'
              justifyContent='space-between'>
              <Typography variant='h3'>EDI</Typography>
            </Box>
            <CodeMirror
              height='40vh'
              maxWidth='50vw'
              className={classes.editor}
              value={ediResult}
              editable={false}
            />
          </Box>
        </Box>
      )}
    </>
  )
}
